// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar__avatar-W7Bw","name":"Avatar__name-dRLD","photo":"Avatar__photo-aIjv","img":"Avatar__img-lXs7"};